<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Menu Groups</h1>
                <v-btn color="black" prepend-icon="mdi-plus" @click="createDialogSwitch = true">Add</v-btn>
            </v-col>
        </v-row>
        <h3></h3>
        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th>Title</th>
                        <th>Key</th>
                        <th>Type</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="menuGroup in menuGroups" v-if="menuGroups.length" class="text-left">
                        <td>{{ menuGroup.title }}</td>
                        <td>{{ menuGroup.key }}</td>
                        <td class="text-capitalize">{{ menuGroup.type }}</td>
                        <td>
                            <v-btn-group density="compact" divided variant="outlined">
                                <v-btn :disabled="editDialogSwitch" class="text-warning" prepend-icon="mdi-pencil"
                                       size="x-small" @click="editMenuGroup(menuGroup)">Edit
                                </v-btn>
                                <v-btn class="text-error" prepend-icon="mdi-delete" size="x-small"
                                       @click="deleteMenuGroup(menuGroup)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" class="text-center" colspan="4">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else class="text-center" colspan="4">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <v-row v-if="totalPages > 1" justify="center">
            <v-col cols="8">
                <v-container class="max-width">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        class="my-4"
                        density="compact"
                        @click="fetchMenuGroups"
                    ></v-pagination>
                </v-container>
            </v-col>
        </v-row>
    </v-container>

    <Create v-if="createDialogSwitch" v-model="createDialogSwitch" @addMenuGroup="addMenuGroup"/>
    <Edit v-if="editDialogSwitch" v-model="editDialogSwitch" :menuGroup="selectedMenuGroup"
          @updateMenuGroup="updateMenuGroup"/>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import Edit from "@/components/dialogs/menu-groups/Edit.vue";
import Create from "@/components/dialogs/menu-groups/Create.vue";

const createDialogSwitch = ref(false);
const {showSnackbar} = useSnackbarStore();
const editDialogSwitch = ref(false);
const selectedMenuGroup = ref(null);
const menuGroups = ref([]);
const currentPage = ref(1);
const totalPages = ref(1);
const loading = ref(true);

onMounted(() => {
    fetchMenuGroups();
});

const fetchMenuGroups = () => {
    send('get', `admin/menu-groups?page=${currentPage.value}`)
        .then((response) => {
            menuGroups.value = response.data.data.data;
            totalPages.value = response.data.data.last_page;
            currentPage.value = response.data.data.current_page;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('menuGroups could not be loaded', 'error')
        }).finally(() => loading.value = false)
}
const addMenuGroup = (menuGroup) => {
    menuGroups.value.unshift(menuGroup);
}
const editMenuGroup = (menuGroup) => {
    selectedMenuGroup.value = menuGroup;
    editDialogSwitch.value = true;
}
const updateMenuGroup = (menuGroup) => {
    menuGroups.value.map((comp, index) => {
        if (comp.id === menuGroup.id) {
            menuGroups.value[index] = menuGroup;
        }
    });
}
const deleteMenuGroup = (menuGroup) => {
    if (confirm(`Are you sure to delete "${menuGroup.title}" menuGroup?`)) {
        send('delete', `admin/menu-groups/${menuGroup.id}`)
            .then((response) => {
                if (response.data.success) {
                    menuGroups.value.map((item, index) => {
                        if (item.id === menuGroup.id) {
                            menuGroups.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showSnackbar(error.response.data.message, 'error')
                } else {
                    showSnackbar(`"${menuGroup.title}" menuGroup could not be deleted`, 'error')
                }
            })
    }
}
</script>
